


















































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { FormLoja, Usuario } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { UsuariosModule } from '@/store/vuex/usuario/UsuariosStore'
import { usuarioParaOperador } from '@/shareds/loja-shareds'
import AvatarDeUsuario from '@/components/usuario/AvatarDeUsuario.vue'
import DialogoDeBuscaDeUsuario from '@/components/usuario/DialogoDeBuscaDeUsuario.vue'

@Component({
	components: { AvatarDeUsuario, DialogoDeBuscaDeUsuario },
})
export default class SecaoFuncionarios extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja

	inserirFuncionario(usuario: Usuario) {
		const jaEstaNaLoja = this.loja.usuarios.some(({ id }) => usuario.id === id)
		if (jaEstaNaLoja) {
			AlertModule.setError(`${usuario.nome} já consta no quadro de funcionários`)
			return
		}
		this.loja.usuarios.push(usuarioParaOperador(usuario))
	}

	removerUsuarioDaLoja(id: string) {
		this.loja.usuarios = this.loja.usuarios.filter(usuario => usuario.id !== id)
	}

	descricaoDoPerfil(id: string) {
		const perfil = UsuariosModule.perfil(id)
		return perfil ? `${perfil.nome} - ` : ''
	}
}
